import { conformToMask } from 'react-text-mask'

const allowedKeysRegex = /^\d{1}$/

export const phoneMask = [
  '(',
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  ')',
  ' ',
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  '-',
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
]

export const conformToPhoneMask = (val = '') => conformToMask(val, phoneMask, { guide: false })
